
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/layout/Layout';
import AdultBeginnerHero from '@/components/adultBeginner/AdultBeginnerHero';
import AdultBeginnerBenefits from '@/components/adultBeginner/AdultBeginnerBenefits';
import AdultBeginnerJourney from '@/components/adultBeginner/AdultBeginnerJourney';
import AdultBeginnerTestimonials from '@/components/adultBeginner/AdultBeginnerTestimonials';
import AdultBeginnerFAQ from '@/components/adultBeginner/AdultBeginnerFAQ';
import { preloadCriticalImages } from '@/utils/optimizeImages';
import AboutCTA from '@/components/about/AboutCTA';

const AdultBeginnerPianoLessons = () => {
  // Preload critical images for performance
  useEffect(() => {
    preloadCriticalImages([
      '/lovable-uploads/c3099eea-1cdc-462a-9e3c-85f757436352.png'
    ]);
  }, []);

  return (
    <Layout>
      <div id="top"></div>
      <Helmet>
        <title>Klaverundervisning for voksne begyndere | Det er aldrig for sent at starte</title>
        <meta name="description" content="Klaverundervisning specielt tilpasset voksne begyndere. Effektive undervisningsmetoder og repertoire, der passer til voksne. Book en gratis prøvetime!" />
        <link rel="canonical" href="https://pianoundervisning.dk/klaverundervisning-voksne" />
        <meta property="og:title" content="Klaverundervisning for voksne begyndere | Det er aldrig for sent at starte" />
        <meta property="og:description" content="Klaverundervisning specielt tilpasset voksne begyndere. Effektive undervisningsmetoder og repertoire, der passer til voksne." />
        <meta property="og:url" content="https://pianoundervisning.dk/klaverundervisning-voksne" />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="klaverundervisning voksne, klaver for voksne begyndere, lær at spille klaver som voksen, musikundervisning for voksne" />
      </Helmet>

      <AdultBeginnerHero />
      <AdultBeginnerBenefits />
      <AdultBeginnerJourney />
      <AdultBeginnerTestimonials />
      <AdultBeginnerFAQ />
      <AboutCTA 
        title="Start din musikalske rejse i dag"
        description="Det er aldrig for sent at lære at spille klaver. Oplev glæden ved musik med undervisning, der er tilpasset voksne begyndere."
        primaryButtonText="Book gratis prøvetime"
        secondaryButtonText="Se alle undervisningstilbud"
      />
    </Layout>
  );
};

export default AdultBeginnerPianoLessons;
